import type { Conversation } from '@/types';

/**
 * Newest-first by `created`. Pure + stable: returns a fresh array so
 * upstream consumers can rely on referential equality semantics when
 * the source data is unchanged via React Compiler memoization.
 *
 * /my returns hunt iteration conversations in DDB sort-key order, which
 * is not the same as created-time order — sorting client-side keeps the
 * chat list deterministic and puts the most recent iteration on top.
 */
export function sortByCreatedDesc(
  list: readonly Conversation[]
): Conversation[] {
  return [...list].sort(
    (a, b) => new Date(b.created).getTime() - new Date(a.created).getTime()
  );
}
